export default {
  articles: {
    breadcrumbHome: "Accueil",
    breadcrumbGuides: "Guides",
    author: "Équipe éditoriale USFansLink",
    readingTime: "7 min de lecture",
    lastUpdated: "Dernière mise à jour : août 2026",
    notFound: "Guide introuvable",
    tocTitle: "Sommaire",
    s1Title: "Pourquoi ce sujet compte",
    s1Body:
      "Chaque étape du processus de recherche USFans, des listes de produits aux détails de livraison, influence les décisions que vous prenez avant d'acheter. Quand vous comprenez comment cet élément s'inscrit dans le tableau global, vous pouvez comparer les options avec plus de confiance et éviter les surprises.",
    s2Title: "Comment commencer",
    s2Body:
      "Commencez par les catégories ou colonnes qui comptent le plus pour vous, puis affinez étape par étape. Une approche simple et reproductible — examiner, comparer, puis confirmer les détails — garde votre recherche organisée et facilite le repérage des informations dont vous avez vraiment besoin.",
    s3Title: "À garder en tête",
    s3Body:
      "Les détails peuvent changer, et toutes les options ne fonctionnent pas de la même façon. Revérifiez les notes les plus récentes, confirmez les informations de livraison et de paiement, et restez prudent face à tout ce qui semble inhabituel. Quelques minutes de plus au départ font souvent gagner du temps et des soucis ensuite.",
    faqTitle: "Questions fréquentes",
    faq: [
      {
        q: "Ce guide est-il tenu à jour ?",
        a: "Nous révisons et actualisons régulièrement nos guides, mais des détails comme les frais de livraison et les offres peuvent changer rapidement. Confirmez toujours les informations les plus récentes sur la boutique avant d'acheter.",
      },
      {
        q: "Ai-je besoin d'un compte pour utiliser ces informations ?",
        a: "Non, la plupart de ces guides et ressources sont gratuits à lire. Vous devrez peut-être vous connecter pour finaliser un achat sur la boutique principale.",
      },
      {
        q: "Où trouver plus de ressources USFans ?",
        a: "Parcourez les guides associés sur cette page ou revenez à l'accueil USFansLink pour explorer l'ensemble des ressources.",
      },
    ],
    relatedTitle: "Ressources USFans associées",
    relatedIntro: "Continuez votre exploration avec ces guides et ressources associés.",
    relatedHome: "Retour à l'accueil USFansLink",
    relatedGuide: "Guide complet du tableur USFans",
    conclusionTitle: "Continuez votre recherche USFans",
    conclusionBody:
      "Utilisez ce que vous avez appris ici pour poursuivre votre recherche avec plus de confiance, et explorez les catégories et guides organisés quand vous êtes prêt.",
    cta: "Explorer le tableur USFans",
    backHome: "Retour à l'accueil",
    disclaimer:
      "Ce guide est une ressource d'information indépendante et n'est pas affiliée ni approuvée par USFans, sauf indication explicite.",
    list: {
      "usfans-spreadsheet-list": {
        title: "Liste de produits du tableur USFans : parcourir et comparer",
        excerpt:
          "La liste de produits du tableur USFans réunit articles, catégories et vendeurs dans une seule vue. Apprenez à la parcourir, comparer les options et affiner les produits avant de passer à la boutique.",
        tag: "Guide produits",
      },
      "usfans-seller-spreadsheet": {
        title: "Tableur des vendeurs USFans : rechercher les vendeurs intelligemment",
        excerpt:
          "L'information sur le vendeur peut décider d'un achat. Ce guide explique comment le tableur des vendeurs vous aide à examiner l'historique, comparer les options et repérer les vendeurs qui valent le coup.",
        tag: "Guide vendeurs",
      },
      "how-to-use-usfans-spreadsheet": {
        title: "Comment utiliser le tableur USFans : guide pas à pas",
        excerpt:
          "Nouveau sur le tableur USFans ? Ce guide pas à pas parcourt les catégories, filtres et colonnes pour passer d'un écran vide à une liste courte de produits sans tâtonner.",
        tag: "Guide débutant",
      },
      "usfans-product-research": {
        title: "Guide de recherche de produits USFans : trouvez ce qu'il vous faut plus vite",
        excerpt:
          "Une bonne recherche de produits fait gagner du temps et de l'argent. Apprenez un flux simple pour comparer les articles, vérifier les détails et établir une liste courte avant d'acheter.",
        tag: "Guide de recherche",
      },
      "usfans-seller-research": {
        title: "Guide de recherche des vendeurs USFans : repérer les vendeurs fiables",
        excerpt:
          "Une vérification soigneuse du vendeur réduit le risque avant d'acheter. Ce guide couvre ce qu'il faut chercher dans l'historique, les avis et les détails de livraison, et comment signaler ce qui est suspect.",
        tag: "Guide de recherche",
      },
      "usfans-shipping-guide": {
        title: "Guide de livraison USFans : options, coûts et suivi",
        excerpt:
          "Les options et coûts de livraison varient beaucoup selon le vendeur et la destination. Ce guide explique les méthodes courantes, ce qui influence le délai et comment confirmer le coût final avant de commander.",
        tag: "Guide livraison",
      },
      "usfans-coupon-guide": {
        title: "Guide des coupons USFans : trouver et appliquer les offres actuelles",
        excerpt:
          "Les coupons vont et viennent, et tous les codes ne fonctionnent pas à chaque commande. Découvrez où apparaissent les offres, comment les appliquer et quoi vérifier avant le paiement.",
        tag: "Guide économies",
      },
      "usfans-discount-code-guide": {
        title: "Guide des codes promo USFans : où apparaissent les bonnes affaires",
        excerpt:
          "Les codes promo peuvent réduire votre total, mais seulement s'ils correspondent à votre commande. Ce guide explique où ils apparaissent, comment les tester et pourquoi un code peut ne pas s'appliquer.",
        tag: "Guide économies",
      },
      "usfans-warehouse-guide": {
        title: "Guide de l'entrepôt USFans : stockage et livraison expliqués",
        excerpt:
          "Les processus d'entrepôt influencent la rapidité d'expédition de votre commande. Découvrez comment fonctionne le stockage, ce que cela signifie pour le délai et quoi vérifier dans les notes d'entrepôt.",
        tag: "Guide logistique",
      },
      "usfans-qc-guide": {
        title: "Guide QC USFans : vérifier la qualité avant d'acheter",
        excerpt:
          "Les photos et listes de contrôle qualité aident à repérer les problèmes avant l'expédition. Ce guide explique quoi chercher, comment lire les photos QC et comment signaler tôt vos doutes.",
        tag: "Guide qualité",
      },
    },
  },
};